import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { translationPropType } from '@eb/i18n';

import { Icon } from '@eb/eds-icon';
import { LogoWordmarkBrand } from '@eb/eds-iconography';

import { ICON_TYPE_PROP_TYPE } from '@eb/eds-icon';

import './PageHeader.scss';

const HeaderIcon = ({ iconType, iconColor, iconSize }) => {
    const classes = classNames(
        'eds-l-mar-bot-6',
        'eds-fx--pop eds-fx--delay-1',
        'eds-bg-color--white',
        'authentication__page-header__icon',
    );

    return (
        <div className={classes} data-spec="page-header-icon">
            <Icon size={iconSize} type={iconType} color={iconColor} />
        </div>
    );
};

const HeaderTitle = ({ headerText }) => (
    <h1 className="eds-text-hm eds-l-mar-bot-10" data-spec="page-header-title">
        {headerText}
    </h1>
);

const HeaderSubTitle = ({ subtitleText }) => {
    let component = null;

    if (subtitleText) {
        const headerSubTitleClasses = classNames(
            //Adding the set style so that the subtitle text maintains consistent height as text length changes with screen size.
            //Prevents email field from jumping around the page.
            'eds-l-mar-bot-8',
            'eds-text-color--grey-600',
            'eds-l-mar-hor-3',
            'eds-text-bm',
        );

        component = (
            <div
                className={headerSubTitleClasses}
                data-spec="page-header-subtitle"
            >
                {subtitleText}
            </div>
        );
    }

    return component;
};

export default class PageHeader extends React.PureComponent {
    static propTypes = {
        headerText: translationPropType.isRequired,
        iconType: ICON_TYPE_PROP_TYPE,
        subtitleText: translationPropType,
        iconColor: PropTypes.string,
        picture: PropTypes.string,
    };

    static defaultProps = {
        iconColor: 'ui-orange',
        iconSize: 'medium',
    };

    render() {
        const {
            headerText,
            subtitleText,
            iconType,
            iconColor,
            iconSize,
            picture,
        } = this.props;
        let icon = null;

        if (iconType) {
            icon = (
                <HeaderIcon
                    iconType={iconType}
                    iconColor={iconColor}
                    iconSize={iconSize}
                />
            );
        }

        if (picture) {
            icon = (
                <img
                    className="authentication__page-header__picture"
                    src={picture}
                    alt={picture}
                />
            );
        }

        return (
            <div className="authentication__page-header eds-text--center">
                {icon}

                <HeaderTitle
                    headerText={headerText}
                    subtitleText={subtitleText}
                />
                <HeaderSubTitle subtitleText={subtitleText} />
            </div>
        );
    }
}
